import axios from "axios";
import { useEffect, useState } from "react";
import { webUrlNode } from "../../../constants/appInfo";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import ListStudentSelectorModal from "../../User/lists/ListStudentSelectorModal";
import FolderFilterCardTwo from "../CreateContent/FolderFilterCardTwo";
export default function AddStudentsToBatchModal({
  
  existingStudents = [],
  onClose,
  onCompleted
}) {

    const {batchId} = useParams();
  const API_BASE = "https://api.ilogically.com/api";
  const AppToken = useSelector((state)=>state?.app?.app?.AppToken);

  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [showSelector, setShowSelector] = useState(false);


  // 🔎 Filters
  const [search, setSearch] = useState("");
  const [role, setRole] = useState("student");
  const [status, setAccountStatus] = useState("active");
  const [registeredFrom, setRegisteredFrom] = useState("");
  const [registeredTo, setRegisteredTo] = useState("");

  const [sortBy, setSortBy] = useState("userRegisteredDate");
  const [sortOrder, setSortOrder] = useState("DESC");

  const [limit] = useState(10);
  const [offset, setOffset] = useState(0);


  async function fetchUsers() {

    setLoading(true);

    try {

      const res = await axios.get(`${API_BASE}/users`, {
         params: {
            role,
            search,
            status,
            registeredFrom,
            registeredTo,
            sortBy,
            sortOrder,
            limit,
            offset,
            appToken: AppToken
          }
      });

      setUsers(res.data || []);

    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchUsers();
  }, [role, status,registeredFrom,registeredTo,search, offset, sortBy, sortOrder]);
 const nextPage = () => {
    setOffset(prev => prev + limit);
  };

  const prevPage = () => {
    setOffset(prev => Math.max(prev - limit, 0));
  };
  function toggleSelect(id) {

    if (existingStudents.includes(id)) return;

    setSelected(prev =>
      prev.includes(id)
        ? prev.filter(x => x !== id)
        : [...prev, id]
    );
  }
const selectAll = () => {
  setSelected(prev => [
    ...new Set([...prev, ...users.map(s => s.ID)])
  ]);
};
  async function bulkEnroll() {

    if (!selected.length) return;

    setSubmitting(true);

    try {

      await axios.post(
        `${webUrlNode}/api/batches/${batchId}/enroll-bulk?appToken=${AppToken}`,
        {
          
          studentIds: selected
        }
      );

      onCompleted && onCompleted();
      onClose();

    } catch (e) {
      console.error(e);
      alert("Bulk enroll failed");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div style={modalWrapper}>

      <div style={modalStyle}>
        <h3>Add Students to Batch</h3>
        <div style={{display:"flex",justifyContent:"left",}}>
          <FolderFilterCardTwo  activeCard={showSelector?false:true}   icon={6} title =" Select All" onClickPopup={selectAll
}  /> <FolderFilterCardTwo  activeCard={showSelector?true:false}   icon={6} title =" Show List" onClickPopup={()=>{setShowSelector(true)}}  />  
</div> 
{showSelector?<ListStudentSelectorModal
  onClose={() => setShowSelector(false)}
  onEnroll={(studentIds) => {
setSelected(studentIds);setShowSelector(false);
setTimeout(()=>{bulkEnroll()},100) ;

    // call batch enroll API here

  }}
/>:""}
       <div style={{ marginBottom: 20, display: "grid", gap: 10 }}>
<div  className="ikcraft_login-input-card" style={{marginTop:"-30px",padding:"0px"}}>

        <input   className="CreateCourseStepsOuterTextbox" 
          placeholder="Search name or email"
          value={search}
          onChange={(e) =>{ setSearch(e.target.value); setOffset(0)}}
        />
</div>
        <div style={{ display: "flex", gap: 10 }}>

          <select 
          style={{fontSize:"20px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"0px"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}} value={role} onChange={(e) => {setRole(e.target.value); setOffset(0)}}>
            <option value="">All Roles</option>
            <option value="student">Student</option>
            <option value="teacher">Teacher</option>
            <option value="staff">Staff</option>
            <option value="batchbuddy">BatchBuddy</option>
          </select>

          <select
          style={{fontSize:"20px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"0px"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}}
            value={status}
            onChange={(e) => {setAccountStatus(e.target.value); setOffset(0)}}
          >
            <option value="">All Status</option>
            <option value="active">Active</option>
            <option value="blocked">Blocked</option>
          </select>

          <input 
          style={{fontSize:"20px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"0px"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}}
            type="date"
            value={registeredFrom}
            onChange={(e) => {setRegisteredFrom(e.target.value); setOffset(0)}}
          />

          <input
          
          style={{fontSize:"20px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"0px"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}}
            type="date"
            value={registeredTo}
            onChange={(e) => {setRegisteredTo(e.target.value); setOffset(0)}}
          />

        </div>

        <div style={{ display: "flex", gap: 10 }}>

          <select
          
          style={{fontSize:"20px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"0px"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}} value={sortBy} onChange={(e) => {setSortBy(e.target.value); setOffset(0)}}>
            <option value="userRegisteredDate">Registered Date</option>
            <option value="firstName">First Name</option>
            <option value="lastName">Last Name</option>
            <option value="userEmail">Email</option>
            <option value="role">Role</option>
          </select>

          <select 
          style={{fontSize:"20px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"0px"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}} value={sortOrder} onChange={(e) => {setSortOrder(e.target.value); setOffset(0)}}>
            <option value="DESC">DESC</option>
            <option value="ASC">ASC</option>
          </select>

          

        </div>

      </div>

        {loading && <p>Loading...</p>}

        <div style={{ maxHeight:300, overflowY:"auto" }}>
          {users.map(u => {

            const isEnrolled = existingStudents.some(
  s => s.studentId === u.ID
);
            const isChecked = selected.includes(u.ID);

            return (
              <div key={u.ID} style={rowStyle}>

                <input
                  type="checkbox"
                  disabled={isEnrolled}
                  checked={isChecked}
                  onChange={() => toggleSelect(u.ID)}
                />

                <div>
                  <strong>{u.firstName} {u.lastName}</strong>
                  <div style={{ fontSize:12 }}>
                    {u.userEmail}
                    <div>{isEnrolled && (
                  <span style={{ fontSize:12, color:"green" }}>
                    Already enrolled
                  </span>
                )}</div>
                  </div>
                </div>

                

              </div>
            );
          })}
        </div>

        <div style={{ marginTop:15, display:"flex", justifyContent:"space-between" }}>
          <span>
            Selected: {selected.length}
          </span>
{/* 📄 Pagination */}
      <div style={{  }}>
        <button style={{fontSize:"12px",color:"#222222",background:"rgba(144, 202, 249,0.51)",border:"0px"
          ,borderRadius:"5px",cursor:"pointer",height:"35px", margin:"5px"}} onClick={prevPage} disabled={offset === 0}>
          Previous
        </button>

        <button  onClick={nextPage} style={{fontSize:"12px",color:"#222222",background:"rgba(144, 202, 249,0.51)",border:"0px"
          ,borderRadius:"5px",cursor:"pointer",height:"35px", margin:"5px"}}>
          Next
        </button>
      </div>
          <div>
            <button style={{fontSize:"12px",color:"#222222",background:"rgba(5, 5, 5, 0.1)",border:"0px"
          ,borderRadius:"5px",cursor:"pointer",height:"35px", margin:"5px"}} onClick={onClose}>Cancel</button>

            <button
              onClick={bulkEnroll}
              disabled={!selected.length || submitting}
              style={{fontSize:"12px",color:"#222222",background:"rgba(144, 202, 249,1)",border:"0px"
          ,borderRadius:"5px",cursor:"pointer",height:"35px", margin:"5px"}}
            >
              {submitting ? "Adding..." : "Add Selected"}
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}

const modalWrapper = {
  position:"fixed",
  inset:0,
  background:"rgba(0,0,0,0.35)",
  display:"flex",
  justifyContent:"center",
  alignItems:"center",
  zIndex:1000
};

const modalStyle = {
  width:600,
  background:"#fff",
  padding:20,
  borderRadius:8
};

const rowStyle = {
  display:"flex",
  alignItems:"left",
  justifyContent:"left",gap:"20px",
  padding:8,
  borderBottom:"1px solid #eee"
};